<template>
    <div
        role="alert"
        data-type="validation-error-message"
        class="select-none animate-shake z-[3] font-bold text-red"
    >
        <span>{{ message && te(message) ? translate(message) : message }}</span>
    </div>
</template>

<script setup lang="ts">
interface Props {
    message: string | null | undefined;
}

defineProps<Props>();

const { t: translate, te } = useI18n();
</script>
